/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Button } from "@mui/material";

export const StyledButton = styled(Button)({
  '&.Mui-disabled':{
    backgroundColor: '#001b59',
  },
  '&:hover': {
    textTransform: 'none',
    fontWeight: '600',
    boxShadow: 'none',
    backgroundColor: '#001b59',
    borderRadius: '8px',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  backgroundColor: '#395bbd',
  borderRadius: '8px',
  color: 'white',
})
